import React from 'react';
import PropTypes from 'prop-types';

export default class Welcome extends React.Component {
	static propTypes = {
		onNextPage: PropTypes.func,
	};

	constructor( props ) { 
		super( props );

		this.state = { 
		};
	}

	render() {
		return ( <div className="signupprocess_container">
			<h2>Welcome to DragonTeach</h2>

			<p>To begin, you will need to register an account on this system in order to generate 
				your very own WordPress instance.</p>

			<div className="button_container">
				<input type="button" value="Next Page" onClick={ () => { this.props.onNextPage(); }} />
			</div>
		</div>
		);
	}
}